import { Text, View } from '@react-pdf/renderer'

const Header = () => (
  <View
    style={{
      margin: '32px 24px 0',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between'
    }}
  >
    <View style={{ fontSize: 16, fontWeight: 700 }}>
      <Text>Акт осмотра товара</Text>
      <Text>Тексеру актici</Text>
    </View>
  </View>
)

export default Header
